export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Отображаемые колонки"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сброс"])}
}